export class LocalStore {
  constructor(storage, options = {}) {
    this.storage = storage;
    this.prefix = options.prefix || "cache";
    this.debug = Boolean(options.debug);
  }

  toStorageKey(key) {
    return `${this.prefix}:${key}`;
  }

  async fetch(key) {
    if (!this.storage) return null;

    try {
      const raw = this.storage.getItem(this.toStorageKey(key));
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return null;

      const { value, expiresAt } = parsed;
      if (typeof expiresAt === "number" && Date.now() > expiresAt) {
        this.storage.removeItem(this.toStorageKey(key));
        return null;
      }

      return value ?? null;
    } catch (error) {
      if (this.debug) {
        // eslint-disable-next-line no-console
        console.warn("LocalStore.fetch failed", error);
      }
      return null;
    }
  }

  async store(key, value, ttlMs) {
    if (!this.storage) return;

    try {
      const payload = {
        value,
        expiresAt:
          typeof ttlMs === "number" && ttlMs > 0 ? Date.now() + ttlMs : null,
      };

      this.storage.setItem(this.toStorageKey(key), JSON.stringify(payload));
    } catch (error) {
      if (this.debug) {
        // eslint-disable-next-line no-console
        console.warn("LocalStore.store failed", error);
      }
    }
  }
}

